<section class="mobile-notifications" aria-live="polite">
  <div class="mobile-notifications__actions">
    <button
      type="button"
      pButton
      pRipple
      class="p-button-text"
      [disabled]="!hasUnread"
      (click)="markAllAsRead()"
    >{{ 'shared.mobile_navigation.mark_all_read' | translate }}</button>
  </div>

  <div *ngIf="loading" class="mobile-notifications__state">
    <app-spinner [inline]="true" size="1em"></app-spinner>
  </div>

  <div *ngIf="!loading && !notifications.length" class="mobile-notifications__state">
    <i class="pi pi-bell"></i>
    <p>{{ 'shared.top_bar.notifications.no_new_notifications' | translate }}</p>
  </div>

  <ul *ngIf="!loading && notifications.length" class="mobile-notifications__list">
    <li *ngFor="let notification of notifications" [class.mobile-notifications__item--unread]="notification.readAt === null">
      <app-notification-item [notification]="notification" variant="page"
                             (resolved)="removeResolvedNotification($event)"></app-notification-item>
    </li>
    <li *ngIf="loadingMore" class="mobile-notifications__load-state" aria-live="polite">
      <app-spinner [inline]="true" size="1em"></app-spinner>
    </li>
    <li *ngIf="!hasMore && notifications.length" class="mobile-notifications__load-state mobile-notifications__load-state--end">
      {{ 'common.already_on_recent' | translate }}
    </li>
  </ul>
</section>
